import {
  InsufficientAccessBackground,
  MilestonesDetailSection,
  MilestonesHeaderSection,
  StyledActivityCardBackground,
  useAccessState
} from 'modules';

import {
  Outlet,
  useParams
} from 'react-router-dom';


export const MilestonesActivity = () => {
  const params = useParams();
  const access = useAccessState('Milestone');

  if (params.milestoneId) {
    return (
      <Outlet />
    );
  }

  return access.view
    ? (
      <StyledActivityCardBackground.FC>
        <MilestonesHeaderSection.FC />
        <MilestonesDetailSection.FC />
      </StyledActivityCardBackground.FC>
    )
    : (
      <InsufficientAccessBackground.FC />
    );
};
